(ns frontend.view.reports.custom.diamond-edge-ventures-deals
  (:require
   [common.entity :as entity]
   [common.localization :as loc]
   [common.time :as c-time]
   [common.util :as cu]
   [frontend.exports.excel :as excel]
   [frontend.state.current-session :as session]
   [frontend.view.components.clipboard :as clipboard]
   [frontend.zap-time :as zap-time]
   [reagent.core :as r]
   [frontend.view.reports.custom.diamond-edge-common :as diamond-edge-common]
   [frontend.view.reports.custom.diamond-edge-ventures.report-1-total-engagement :as report-1-data]
   [ui.components.card.view :as card]
  ))

(defn tenant-table
  [{:keys [view-name header-row data-rows footer-row]}]
  [card/card
   [card/header
    [:div
     {:class "flex items-center gap-2"}
     [:span
      {:class "block font-semibold"}
      view-name]]

    [:div
     {:class "flex items-center gap-2"}
     [:i.fal.fa-copy.mr-3.pointer
      {:title    (loc/tr :copy-to-clipboard)
       :on-click (fn [_]
                   (clipboard/copy-as-tsv (concat [header-row]
                                                  data-rows
                                                  [footer-row])))}]
     [:i.fal.fa-file-excel.pointer
      {:title    (loc/tr :save-as-excel)
       :on-click (fn [_]
                   (excel/export-array-data
                    view-name
                    (concat [header-row] data-rows [footer-row])))}]]]
   [card/body
    [:table.zap-simple-table.zap-simple-table--md.w-100
     [:thead
      [:tr
       (->> header-row
            (map-indexed (fn [idx heading]
                           ^{:key (str view-name "-header-" idx)}
                           [:th heading]))
            (doall))]]
     [:tbody
      {:key (str view-name "-body")}
      (->> data-rows
           (map-indexed
            (fn [row-idx row-data]
              [:tr
               {:key (str view-name "-row-" row-idx)}
               (->> row-data
                    (map-indexed (fn [idx cell-data]
                                   [:td
                                    {:key        (str view-name "-" row-idx "-" idx)
                                     :class-name (if (= 0 idx) "string-value" "number-value")}
                                    cell-data]))
                    (doall))]))
           (doall))]
     [:tfoot
      [:tr
       (->> footer-row
            (map-indexed (fn [idx footer-cell-data]
                           [:td
                            {:key (str view-name "-footer-" idx)}
                            footer-cell-data]))
            (doall))]]]]])

(defn throughput-report
  [filter-state]
  (let [deals-pipeline-id (->> @session/pipelines
                               (cu/filter-by :pipeline/entity-type :entity.type/oppo)
                               (cu/filter-by :pipeline/name "Commercialization")
                               (first)
                               (:db/id))
        stages (->> @session/stages
                    (cu/filter-by :stage/pipeline deals-pipeline-id)
                    (sort-by :common/ord))
        data
        (->>
         (report-1-data/oppos-in-scope @filter-state)
         (filter (fn [o]
                   (some #{(:oppo/status o)}
                         [:oppo.status/on-hold :oppo.status/ok])))
         (sort-by :common/lower-case-str)
         (mapv
          (fn [oppo]
            (let [chronological-stage-changes (->> oppo
                                                   :common/change-meta
                                                   (cu/filter-by :change/type :change.type/stage-change)
                                                   (sort-by :common/updated-on))
                  entered-by-stage-id (->> chronological-stage-changes
                                           (map (fn [c]
                                                  [(:enter-stage (:change/value c))
                                                   (zap-time/long->formatted-date (:common/updated-on c))]))
                                           (into {}))
                  time-by-stage-id
                  (->>
                   stages
                   (map (fn [stage]
                          (let [stage-id (:db/id stage)
                                changes-to-stage
                                (->> chronological-stage-changes
                                     (reverse)
                                     (take-while (fn [c]
                                                   (not= stage-id (:enter-stage (:change/value c)))))
                                     (reverse))
                                changes-with-stage
                                (when (and (seq chronological-stage-changes)
                                           (not= (count changes-to-stage)
                                                 (count chronological-stage-changes)))
                                  (concat [(nth chronological-stage-changes
                                                (- (count chronological-stage-changes) 1 (count changes-to-stage)))]
                                          changes-to-stage))]
                            [stage-id
                             (cond (empty? changes-with-stage)
                                   ""
                                   (= 1 (count changes-with-stage))
                                   ""
                                   :else
                                   (zap-time/long->formatted-date (:common/updated-on (first changes-with-stage))))])))
                   (into {}))]
              (concat
               [(:oppo/name oppo)
                (entity/display-string (session/get-entity (:oppo/stage oppo)))]
               (->> stages
                    (map (fn [stage]
                           (let [last-entered (get entered-by-stage-id (:db/id stage))]
                             [(or last-entered
                                  "")
                              (get time-by-stage-id (:db/id stage))])))
                    (mapcat identity)
                    (vec))
               #_[(into [:ul]
                        (->> chronological-stage-changes
                             (map (fn [c]
                                    [:li
                                     (str (entity/display-string (session/get-entity (:enter-stage (:change/value c))))
                                          " - "
                                          (zap-time/long->formatted-date-time (:common/updated-on c)))]))
                             (vec)))])))))]
    [tenant-table
     {:view-name  "Deals throughput"
      :header-row (concat ["Deal" "Current stage"]
                          (->> stages
                               (mapcat (fn [stage]
                                         [(loc/tr :entered-stage [(:stage/name stage)])
                                          (loc/tr :exited-stage [(:stage/name stage)])]))
                               (vec))
                          #_["Debug"])
      :data-rows  data}]))

(defn get-filter-default-values
  []
  (let [[start-date end-date] (diamond-edge-common/get-start-and-end :date-range-all)]
    {:date-range :date-range-all
     :start-date start-date
     :end-date   end-date}))


(defn view
  [_]
  (let [reports-state (r/atom (get-filter-default-values))]
    (r/create-class
     {:reagent-render
      (fn [_]
        [:<>
         [diamond-edge-common/filters reports-state]
         [:div
          [:div
           [throughput-report reports-state]]]
        ])})))
